import React from 'react';
import { Navbar, Image, Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import BrandImage from '../assets/images/2.png';
import EmpoyledOrStudying from './EmpoyledOrStudying';

const cardTitle = ({ name, selfie }) => (
  <span>
    {selfie && selfie._url ? (
      <Image
        className="user-selfie"
        src={selfie._url}
        alt="Selfie"
        roundedCircle
      />
    ) : (
      <FontAwesomeIcon icon={faUser} />
    )}
    <span className="mx-2">{name}</span>
  </span>
);

const FiterNavbar = ({ currentUser, removeCurrentUser, getStudability }) => {
  return (
    <Navbar collapseOnSelect expand="md" bg="dark" variant="dark">
      <Link to="/" className="brand">
        <Image src={BrandImage} style={{ height: '30px' }} height="30" />{' '}
      </Link>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          {/* <Link to="/">Home</Link> */}
          {currentUser == null ? (
            <>
              <Link to="/login" className="nav-link">
                Login
              </Link>
              {/* <Link to="/cadastro" className="nav-link">Cadastre-se</Link> */}
            </>
          ) : (
            <>
              <Link to="/pulso" className="nav-link">
                Pulso
              </Link>
              {currentUser.roleName === 'Coordinator' ? (
                <>
                  <Link to="/dashboard-pulse" className="nav-link">
                    Dashboard Pulso
                  </Link>
                  {/* <Link to="/roteiro" className="nav-link">Roteiro</Link> */}
                  {/* <Link to="/dashboard" className="nav-link">Dashboard Roteiro</Link> */}
                  {/* <Link to="/board" className="nav-link">Board</Link> */}
                  <Link to="/cursos" className="nav-link">
                    Minhas áreas
                  </Link>
                  <EmpoyledOrStudying getStudability={getStudability} />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Nav>
        {currentUser != null ? (
          <Nav>
            <NavDropdown
              className="mr-4"
              title={cardTitle(currentUser)}
              id="basic-nav-dropdown"
            >
              <Link className="dropdown-item" to="/user">
                Painel do Usuário
              </Link>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={removeCurrentUser}>
                Sair
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        ) : (
          <></>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default FiterNavbar;
